export default "__VITE_ASSET__DoPFXx1H__"